module.exports = __webpack_public_path__ + "static/media/marcelhageman.1dfb184c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/marcelhageman.webp
// module id = 911
// module chunks = 0